import { useAppTranslation } from '@flowus/common/i18n';
import type { FC } from 'react';
import { Images } from 'src/image';

export const Empty: FC<{ className?: string }> = (props) => {
  const { t } = useAppTranslation();
  return (
    <div className={props.className}>
      <div className="text-h2">{t('views.main.template.empty_title')}</div>
      <div className="text-grey3 text-t2 mt-2.5">{t('views.main.template.empty_description')}</div>
      <div className="w-full max-w-4xl">
        <img src={Images.templatesEmpty} className="mt-7 " />
      </div>
    </div>
  );
};
